import type { ReactNode } from 'react';
import React from 'react';
import classnames from 'clsx';

import { FlexColumn, FlexRow } from 'ui-components/components/flex';

import styles from './formatted-price-block.module.css';
import { emptyArray } from 'ui-components/default-props/empty';

type SummaryDetail = {
  key: string;
  ariaLabel?: string;
  description?: ReactNode;
  lineItemPrice?: ReactNode;
  actionElement?: ReactNode;
};

type FormattedPriceBlockProps = {
  blockSectionTitle: ReactNode;
  className?: string;
  price?: ReactNode;
  summaryDetailList?: SummaryDetail[];
  ariaLabel?: string;
};

export const FormattedPriceBlock = ({
  blockSectionTitle,
  className,
  price,
  summaryDetailList = emptyArray as SummaryDetail[],
  ariaLabel,
}: FormattedPriceBlockProps) => {
  return (
    <FlexColumn className={classnames(styles.wrapper, className)}>
      <FlexRow className={styles.header}>
        <FlexColumn>
          <p className={styles.title}>{blockSectionTitle}</p>
        </FlexColumn>
        {price && <FlexColumn ariaLabel={ariaLabel}>{price}</FlexColumn>}
      </FlexRow>
      <div className={styles['detail-grid']}>
        {summaryDetailList.map(({ key, ariaLabel: detailAriaLabel, description, lineItemPrice, actionElement }) => (
          <div key={key} aria-label={detailAriaLabel} className={styles['detail-text']}>
            <div>{description}</div>
            <div>{actionElement}</div>
            <div>{lineItemPrice}</div>
          </div>
        ))}
      </div>
    </FlexColumn>
  );
};
